export default "__VITE_ASSET__Bnw9Ifgj__"